<template>
  <v-row no-gutters>
    <v-col :cols="12">
      <v-row
        :class="breakpoint.smAndDown ? '' : 'tile--rounded'"
        class="cursor--text tileMobile"
        no-gutters align="center"
      >
        <v-col
          :class="breakpoint.smAndDown ?
            'tileMobile tile--rounded' : ''"
          :cols="breakpoint.smAndDown ? 12 : 0"
        >
          <v-text-field
            :id="name"
            v-model="value"
            :maxlength="max"
            :background-color="'tileMobile'"
            :prefix="prefix"
            :suffix="suffix"
            :label="placeholder" solo flat hide-details
            dense
            style="text-align: left;"
            @input="updateValue(value)"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import get from 'lodash.get'

export default {
  name: 'TextField',
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    prefix: {
      type: String,
      default: ' ',
    },
    suffix: {
      type: String,
      default: ' ',
    },
    name: {
      type: String,
      default: 'textField',
    },
    max: {
      type: String,
      default: ' ',
    },
    para: {
      type: String,
      default: ' ',
    },
    mask: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      value: '',
    }
  },
  computed: {
    breakpoint() {
      return get(this.$vuetify, 'breakpoint', {})
    },
  },
  watch: {
    para(v) {
      this.setDatePara(v)
    },

  },
  methods: {
    updateValue(v) {
      this.$emit('input', v)
    },
    setDatePara(v) {
      this.value = v
    },
  },
}
</script>
